<ng-container *ngIf="hasValue;else spinner">
    <nb-card>
        <nb-card-header>Loyalty Points</nb-card-header>
        <nb-card-body>
            <ubs-ofbiz-form [ofbizForm]="ofbizForm" [title]="title" [state] ="state" (resetAction)="resetAction($event)" (openDialogContainerEvent)="openDialogContainer($event)" [target]="target" ></ubs-ofbiz-form>
        </nb-card-body>
    </nb-card>
</ng-container>
<ng-template #spinner>
    <nb-card size="small">
      <nb-card-body [nbSpinner]="true"
      nbSpinnerStatus="danger"
      nbSpinnerSize="large"
      nbSpinnerMessage="Working on it ... "></nb-card-body>
    </nb-card>
    
  </ng-template>
